import axios from "@interfaces/axios.js"

/**
 * ----------------------------------------------------
 * @path   /api/envelopes/:envelopeWsid/participants/:participantWsid/forms
 * @method GET
 * @desc   获取指定参与者信封表单列表
 * 
 * @date   2018-09-20 14:18:40
 * ----------------------------------------------------
 */
export function getParticipantEnvelopeFroms(obj = {}) {
    let {
        envelopeWsid,
        participantWsid
    } = obj

    return axios.get(`/api/envelopes/${envelopeWsid}/participants/${participantWsid}/forms`)
}

/**
 * ----------------------------------------------------
 * @path   /api/envelopes/:envelopeWsid/participants/:participantWsid/forms
 * @method POST
 * @desc   指定参与者创建信封表单列表
 * 
 * @date   2018-09-21 14:25:24
 * ----------------------------------------------------
 */
export function createParticipantEnvelopeFroms(obj = {}) {
    let {
        envelopeWsid,
        participantWsid,
        forms
    } = obj
    
    return axios.post(`/api/envelopes/${envelopeWsid}/participants/${participantWsid}/forms`, {
        forms
    })
}

/**
 * ----------------------------------------------------
 * @path   /api/envelopes/:envelopeWsid/participants/:participantWsid/forms/no-appearance
 * @method POST
 * @desc   添加无外观表单
 * 
 * @date   2020-06-16 19:38:57
 * ----------------------------------------------------
 */
export function createNoappearanceParticipantEnvelopeFroms(obj = {}) {
    let {
        envelopeWsid,
        participantWsid,
        enableNoAppearance,
        forms
    } = obj

    return axios.post(`/api/envelopes/${envelopeWsid}/participants/${participantWsid}/forms/no-appearance`, {
        forms
    },{
        params:{
            enableNoAppearance
        }
    })
}

/**
 * ----------------------------------------------------
 * @path   /api/envelopes/:envelopeWsid/participants/:participantWsid/forms
 * @method PUT
 * @desc   指定参与者修改信封表单列表
 * 
 * @date   2018-09-21 14:25:50
 * ----------------------------------------------------
 */
export function updateParticipantEnvelopeFroms(obj = {}) {
    let {
        envelopeWsid,
        participantWsid,
        forms
    } = obj

    return axios.put(`/api/envelopes/${envelopeWsid}/participants/${participantWsid}/forms`, {
        forms
    })
}

/**
 * ----------------------------------------------------
 * @path   /api/envelopes/:envelopeWsid/forms
 * @method DELETE
 * @desc   删除信封表单列表
 * 
 * @date   2018-01-18 17:12:15
 * ----------------------------------------------------
 */
export function deleteParticipantEnvelopeFroms(obj = {}) {
    let {
        envelopeWsid,
        participantWsid,
        forms
    } = obj

    return axios.delete(`/api/envelopes/${envelopeWsid}/participants/${participantWsid}/forms`, {
        data: {
            forms
        }
    })
}

/**
 * ----------------------------------------------------
 * @path   /api/envelopes/:envelopeWsid/participants/:participantWsid/forms/:formWsid/external-signature/sheca-mobile-shield
 * @method GET
 * @desc   查询上海CA手机盾二维码外部签署方式的流程信息
 * 
 * @date   2020-08-05 10:28:12
 * ----------------------------------------------------
 */
export function getShecaParticipantEnvelopeFroms(obj = {}) {
    let {
        envelopeWsid,
        participantWsid,
        formWsid
    } = obj

    return axios.get(`/api/envelopes/${envelopeWsid}/participants/${participantWsid}/forms/${formWsid}/external-signature/sheca-mobile-shield`)
}

/**
 * ----------------------------------------------------
 * @path   /api/envelopes/:envelopeWsid/participants/:participantWsid/forms/:formWsid/external-signature/sheca-mobile-shield
 * @method POST
 * @desc   生成待签明文并携带二维码
 * 
 * @date   2020-08-05 10:27:51
 * ----------------------------------------------------
 */
export function generateShecaCode(obj = {}) {
    let {
        envelopeWsid,
        participantWsid,
        formWsid,
        qrCodeProvider,
        hashAlgorithm
    } = obj
    
    return axios.post(`/api/envelopes/${envelopeWsid}/participants/${participantWsid}/forms/${formWsid}/external-signature/sheca-mobile-shield`,{
        qrCodeProvider,
        hashAlgorithm
    })
}


// /**
//  * ----------------------------------------------------
//  * @path   /api/envelopes/:envelopeWsid/participants/:participantWsid/without-form
//  * @method GET
//  * @desc   查询无签名表单的信封内容列表
//  * 
//  * @date   
//  * ----------------------------------------------------
//  */
// export function checkDocumentsWithoutForm(obj = {}) {
//     let {
//         envelopeWsid,
//         participantWsid,
//     } = obj
    
//     return axios.get(`/api/envelopes/${envelopeWsid}/participants/${participantWsid}/without-form`)
// }